import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HighlightBlockComponent } from 'src/app/components/highlight-block/highlight-block.component';
import { HighlightDetailModalComponent } from 'src/app/components/highlight-detail-modal/highlight-detail-modal.component';
import { HighlightDetailComponent } from 'src/app/components/highlight-detail/highlight-detail.component';
import { HighlightListComponent } from 'src/app/components/highlight-list/highlight-list.component';
import { HighlightListFilterPipe } from '../../pipes/highlight-list-filter.pipe';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    HighlightListComponent,
    HighlightBlockComponent,
    HighlightDetailComponent,
    HighlightDetailModalComponent,
    HighlightListFilterPipe
  ],
  imports: [CommonModule, SharedModule],
  entryComponents: [HighlightListModule.rootComponent]
})
export class HighlightListModule {
  static rootComponent = HighlightListComponent;
}
